export default __webpack_public_path__ + "media/plus/manage-visual-mobile-34eac704.svg";